import * as React from "react";

const SldierArrowRight = ({
  fill = "#fff",
  stroke = "#fff",
  width,
  height,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    fill="none"
    viewBox="0 0 44 44"
  >
    <g filter="url(#filter0_d_2866_37969)">
      <path
        fill={fill}
        d="M13 20a1 1 0 1 0 0 2zm19.207 1.707a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 0 0-1.414 1.414L30.086 21l-5.657 5.657a1 1 0 0 0 1.414 1.414zM13 22h18.5v-2H13z"
      ></path>
      <circle cx="22" cy="21" r="19" stroke={stroke} strokeWidth="2"></circle>
    </g>
    <defs>
      <filter
        id="filter0_d_2866_37969"
        width="44"
        height="44"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="1"></feOffset>
        <feGaussianBlur stdDeviation="1"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2866_37969"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2866_37969"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);

export default SldierArrowRight;
